import {Button, RadioGroup} from '@thryvlabs/maverick'
import React from 'react'
import {CancelOrderModal} from '../components/cancel-order-modal'
const PARTNER_TYPE_OPTIONS = [
  {
    name: 'Keap Partner',
    value: true,
  },
  {
    name: 'Thryv Legacy Partner',
    value: false,
  },
]
function PartnerSelection({nextStep, partnerType, setPartnerType, prevStep}) {
  return (
    <div className="d-flex flex-col justify-space-between align-items-center w-100">
      <div>
        <h2 className="">Select Your Partner Type</h2>
      </div>
      <div className="d-flex flex-row mb-4">
        <RadioGroup
          data={PARTNER_TYPE_OPTIONS}
          value={partnerType}
          layoutStyles={{
            gap: '20px',
          }}
          row
          onChange={e => {
            setPartnerType(e)
          }}
        />
      </div>
      <div className="d-flex " style={{columnGap: '20px'}}>
        <div>
          <CancelOrderModal cancelUrl="/orders" />
        </div>
        <div>
          <Button
            variant="primary"
            onClick={nextStep}
            disabled={partnerType?.name?.length < 1}
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  )
}
export default PartnerSelection
